export type IcoStartingMethod = 'LP' | 'VIN';

export const enum SELL_OR_TRADE {
    Sell = 0,
    Trade = 1,
    NotSure = 2,
}

export interface IFormMetadata {
    startingMethod?: IcoStartingMethod;
    querystring?: string;
    'condition-capture-override'?: string;
    originPage?: string;
}
